<template>
  <chart-container
    @onPNGDownload="downloadGraphs(titleChart, 'png', downloadId)"
    :titleChart="titleChart"
    @onCSVDownload="downloadGraphs(titleChart, 'csv', downloadId)"
    @onPDFDownload="downloadGraphs(titleChart, 'pdf', downloadId)"
    @zoomEnabled="zoomEnabled"
    @zoomDisabled="zoomDisabled"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :downloadShow="dataSource.categories && Object.keys(dataSource.categories).length > 0"
  >
    <span class="float-right enrol-tabs" slot="header">
      <b-tabs v-model="tabIndexPercentageOfActivityStatus">
        <b-tab v-for="(tabName, index) in tabListActCountSit" :key="index" :title="tabName" />
      </b-tabs>
    </span>
    <fusioncharts slot="body" style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="timeActiveStatusPercentage" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0" />
    <div slot="body" v-else class="align-center p-60">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
    <div slot="body" class="text-left min-height-0" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0">
      <span @click="zoomOutChart()" class="pl-10 pr-5 remove-zoom-icons">
        <img src="/static/img/icon-zoomout.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom Out" />
      </span>
      <span @click="zoomInChart()" class="remove-zoom-icons">
        <img src="/static/img/icon-zoomin.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom In" />
      </span>
    </div>
  </chart-container>
</template>
<script>
import _cloneDeep from "lodash/cloneDeep";
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { downloadCSV, getContrast, primaryColorFnc, getSiteID } from "../../services/visualization/data-management";
import * as dManagement from "@/services/visualization/new-data-management";
import ChartContainer from "@/components/containers/chart-container";

const dataSources = {
  chart: {
    xaxisname: "",
    yaxisname: "Percentage of Forms",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoMedium",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoMedium",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoMedium",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendItemFont: "RobotoRegular",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    showToolTipShadow: "0",
    scrollheight: "10",
    divLineAlpha: "0",
    divLineDashed: "0",
    scrollColor: "#cccccc",
    numbersuffix: "%",
    numVisiblePlot: "20",
    showHoverEffect: "1",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "15",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    showXAxisLine: true,
    legendItemFontSize: "10px",
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    yaxismaxvalue: "100",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 0,
    labelDisplay: "wrap",
    maxLabelHeight: "30"
  },
  categories: [],
  dataset: []
};
export default {
  components: { ChartContainer },
  props: {
    activitiesRaw: [Object, Array],
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => {} },
    xAxisName: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    dataForDownloadCsv: [Object],
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    dataLoaded: { type: Boolean, default: false },
    filterTriggered: { type: Boolean, default: false },
    tabListActCountSit: {
      type: [Object, Array],
      default: () => ["Activities", "Countries"]
    }
  },
  data() {
    return {
      series: null,
      type: "scrollColumn2d",
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: dataSources,
      zoomGraphValueChild: "",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      todayDate: "",
      tDateShow: true,
      getSiteID,
      tabIndexPercentageOfActivityStatus: 0
    };
  },

  watch: {
    activitiesRaw: function(newValue) {
      this.series = newValue ? dManagement.GET_TIME_ACTIVITIES_PERCENTAGE(newValue, this.countrySelected, this.sitesSelected, this.tabIndexPercentageOfActivityStatus) || { series: {}, csvData: {} } : { series: {}, csvData: {} };
    },
    filterTriggered: function() {
      this.series = dManagement.GET_TIME_ACTIVITIES_PERCENTAGE(this.activitiesRaw, this.countrySelected, this.sitesSelected, this.tabIndexPercentageOfActivityStatus) || { series: {}, csvData: {} };
    },
    tabIndexPercentageOfActivityStatus: function(newValue) {
      this.tabIndexPercentageOfActivityStatus = newValue;
      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;
      this.series = dManagement.GET_TIME_ACTIVITIES_PERCENTAGE(this.activitiesRaw, countrySelected, sitesSelected, newValue) || { series: {}, csvData: {} };
      this.generateAxisTimeActivities(this.tabIndexPercentageOfActivityStatus);
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    series: function(newValue) {
      if (newValue.series.categories) {
        this.initGraph(newValue.series);
      } else {
        const dataSources = {};
        dataSources.categories = null;
        this.dataSource = dataSources;
      }
    }
  },

  methods: {
    zoomEnabled() {
      this.$emit("zoomEnabled");
      this.height = "400";
      this.zoomTrigger = true;
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
      this.height = "250";
      this.zoomTrigger = false;
    },
    generateAxisTimeActivities(tab = 0) {
      let axisName = "";
      switch (tab) {
        case 0:
          axisName = "Activities";
          break;
        case 1:
          axisName = "Countries";
          break;
        case 2:
          axisName = "Sites";
          break;
        default:
          axisName = "Activities";
          break;
      }

      return axisName;
    },
    generateCsvHeaders(tabIndexPercentageOfActivityStatus) {
      const headers = ["Percentage Entry Completed", "Percentage Approved", "Percentage Verified", "Percentage Signed Off"];
      switch (tabIndexPercentageOfActivityStatus) {
        case 0:
          headers.unshift("Activity Name");
          break;
        case 1:
          headers.unshift("Countries");
          break;
        case 2:
          headers.unshift("Sites");
          break;
        default:
          break;
      }

      return headers;
    },

    downloadGraphs(titleChart, type, downloadId) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        switch (type) {
          case "csv": {
            const csvHeaders = this.generateCsvHeaders(this.tabIndexPercentageOfActivityStatus);
            this.tDateShow = true;
            const csvContentArray = [];
            this.series.csvData.categories.map((row, index) => {
              const entryCompletedValue = Number(this.series.csvData.dataset[0][index].value);
              const approvedValue = Number(this.series.csvData.dataset[1][index].value);
              const verifiedValue = Number(this.series.csvData.dataset[2][index].value);
              const signedOffValue = Number(this.series.csvData.dataset[3][index].value);

              csvContentArray.push([row.label, Number.isNaN(entryCompletedValue) ? "0%" : Number(entryCompletedValue).toFixed(2) + "%", Number.isNaN(approvedValue) ? "0%" : Number(approvedValue).toFixed(2) + "%", Number.isNaN(verifiedValue) ? "0%" : Number(verifiedValue).toFixed(2) + "%", Number.isNaN(signedOffValue) ? "0%" : Number(signedOffValue).toFixed(2) + "%"]);
            });

            downloadCSV(titleChart, csvHeaders, csvContentArray, this.specificSiteId);
            break;
          }
          case "pdf": {
            let filename = titleChart + "_" + this.todayDate + ".pdf";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".pdf";
            }
            let container = document.querySelector("#" + downloadId);
            this.tDateShow = true;

            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(canvas => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jspdf("p", "mm", "a4");
              const imgProps = pdf.getImageProperties(imgData);
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
              pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
              pdf.save(filename);
            });

            break;
          }
          case "png": {
            let container = document.querySelector("#" + downloadId);
            let filename = titleChart + "_" + this.todayDate + ".png";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".png";
            }
            this.tDateShow = true;

            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(function(canvas) {
              const link = document.createElement("a");
              document.body.appendChild(link);
              link.download = filename;
              link.href = canvas.toDataURL("image/png");
              link.target = "_blank";
              link.click();
            });

            break;
          }
          default:
            break;
        }
      }, 1);
    },
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = 0;
          break;
        case 1:
          numVisPlot = Math.round(0.75 * this.maxColumn);
          break;
        case 2:
          numVisPlot = Math.round(0.5 * this.maxColumn);
          break;
        case 3:
          numVisPlot = Math.round(0.2 * this.maxColumn);
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.timeActiveStatusPercentage.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.timeActiveStatusPercentage.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    initGraph(newValue) {
      const { categories, dataset } = newValue;
      const datasources = _cloneDeep(dataSources);

      dataset[0] = {
        ...dataset[0],
        plottooltext: `<span class='overall-collection-metric-tooltip completed' style='color:${getContrast(primaryColorFnc())}'>$dataValue $seriesName</span>`
      };

      dataset[1] = {
        ...dataset[1],
        plottooltext: `<span class='overall-collection-metric-tooltip missing' style='color:${getContrast("#cab2d6")}'>$dataValue $seriesName</span>`
      };

      dataset[2] = {
        ...dataset[2],
        plottooltext: `<span class='overall-collection-metric-tooltip verified' style='color:${getContrast("#a6cee3")}'>$dataValue $seriesName</span>`
      };
      dataset[3] = {
        ...dataset[3],
        plottooltext: `<span class='overall-collection-metric-tooltip signed-off' style='color:${getContrast("#fb9a99")}'>$dataValue $seriesName</span>`
      };

      if (categories && categories[0].category.length > 0) {
        datasources.categories = [...categories];
        datasources.dataset = dataset;
        this.maxColumn = categories[0].category.length;
      }

      datasources.chart.numvisibleplot = 0;
      datasources.chart.xaxisname = this.generateAxisTimeActivities(this.tabIndexPercentageOfActivityStatus);

      this.dataSource = datasources;
    }
  },

  mounted() {
    if (this.series && this.series.series.categories) {
      this.initGraph(this.series.series);
    }
  }
};
</script>
<style lang="scss" scoped>
#time-to-activities-percentage-containers {
  margin-top: 16px;
  height: 100%;
  width: 100%;
}
</style>
